<template>
  <div class="plus-minus-buttons">
    <span>{{ legend }}</span>
    <InputNumber
      v-if="hasField"
      :value="value"
      @input="fieldInput"
    />
    <img src="@/assets/img/minus-circle-bold-gray.png" alt="" @click="checkMin" />
    <img src="@/assets/img/plus-circle-bold-gray.png" alt="" @click="checkMax" />
  </div>
</template>

<script>
/**
 * Increment or decrement a value
 *
 * @vue-prop {Number} value - Value to increment/decrement
 * @vue-prop {Number} step - Value to increment/decrement by
 * @vue-prop {Number} max - Maximum value after which incrementing won't work
 * @vue-prop {Number} min - Minimum value after which decrementing won't work
 * @vue-prop {String} legend - String to display before the buttons
 * @vue-prop {Boolean} stopPropagation - Prevent the click event propagation when clicking on buttons
 * @vue-prop {Boolean} disabled - Prevent editing the value
 */

import InputNumber from '@/components/input-number.vue';

export default {
  name: 'PlusMinusButtons',
  components: {
    InputNumber,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: NaN,
    },
    min: {
      type: Number,
      default: NaN,
    },
    legend: {
      type: String,
      default: '',
    },
    stopPropagation: Boolean,
    disabled: Boolean,
    hasField: Boolean,
  },
  methods: {
    fieldInput(val) {
      if (!isNaN(this.max) && val > this.max) {
        this.$emit('input', this.max);
      } else if (!isNaN(this.min) && val < this.min) {
        this.$emit('input', this.min);
      } else {
        this.$emit('input', val);
      }
    },
    checkMax(event) {
      if (this.stopPropagation) {
        event.stopPropagation();
      }
      if (this.disabled) {
        return;
      }
      const result = this.value + this.step;
      if (!isNaN(this.max) && result > this.max) {
        this.$emit('input', this.max);
      } else {
        this.$emit('input', result);
      }
      this.$emit('increment');
    },
    checkMin(event) {
      if (this.stopPropagation) {
        event.stopPropagation();
      }
      if (this.disabled) {
        return;
      }
      const result = this.value - this.step;
      if (!isNaN(this.min) && result < this.min) {
        this.$emit('input', this.min);
      } else {
        this.$emit('input', result);
      }
      this.$emit('decrement');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.plus-minus-buttons {
  > * {
    vertical-align: middle;
  }
  img {
    width: 1.5em;
    padding: 0.2em;
    cursor: pointer;

    &:hover {
      background-color: $color-hoverbtn-light-blue;
    }
  }
  input.input-number {
    width: 3.5em;
  }
}
</style>
